import { render, staticRenderFns } from "./tradedetailomni.vue?vue&type=template&id=725ee0f0&scoped=true&"
import script from "./tradedetailomni.vue?vue&type=script&lang=js&"
export * from "./tradedetailomni.vue?vue&type=script&lang=js&"
import style0 from "./tradedetailomni.vue?vue&type=style&index=0&id=725ee0f0&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725ee0f0",
  null
  
)

export default component.exports